// extracted by mini-css-extract-plugin
export var askAiIcon = "_rk-9";
export var container = "_rk-0";
export var groupSeparator = "_rk-a";
export var highlight = "_rk-4";
export var resultIcon = "_rk-5";
export var resultItem = "_rk-7";
export var resultSubtitle = "_rk-3";
export var resultTitle = "_rk-2";
export var resultsList = "_rk-1";
export var searchGroup = "_rk-6";
export var selected = "_rk-8";